import { IDeshabilitarAccesosBatchModel } from "../interfaces/accesos/IDeshabilitarAccesosBatchModel";

export class DeshabilitarAccesosBatchModel implements IDeshabilitarAccesosBatchModel {
    // fechaHoraInduccion: Date;
    // horaInduccion: Time;
    comentarios: string;
    listaIdAccesosPersonales: number[];

    constructor(){
        this.comentarios = '';
        this.listaIdAccesosPersonales = new Array<number>();
    }
}